module.exports = new __parcel__URL__("underwater.de59affb.png").toString();